import cfrUrl from '@/creditflowresearch/infrastructure/url';
import performRequest from '@framework/api/Http/performRequest';

class ModalFormRepository {
  createForm(data) {
    let formData = new FormData();
    let names = Object.keys(data);

    names.forEach((name) => {
      formData.append(name, data[name]);
    });

    return formData;
  }

  sendCorrectionModalForm = async (value, dealId) => {
    let option = {
      headers: {},
      method: 'POST',
      body: this.createForm(value),
    };
    let response = await performRequest(cfrUrl.getFinsightApiUrl(`deals/${ dealId }/correction`), option);

    return response.json();
  };

  sendMissingSomethingModalForm = async (value) => {
    let option = {
      method: 'POST',
      body: this.createForm(value),
      headers: {},
    };
    let response = await performRequest(cfrUrl.getFinsightApiUrl('/mailing/tell-us'), option);

    return response.json();
  };

  joinOpenmarketWaitlist = async (value): Promise<{ result: 'success' } | { result: 'error', reason: string }> => {
    let option = {
      method: 'POST',
      body: this.createForm(value),
      headers: {},
    };
    let response = await performRequest(cfrUrl.getFinsightApiUrl('/mailing/join-openmarket-waitlist'), option);

    return response.json();
  };

  suggestBond = async (payload) => {
    const option = {
      method: 'POST',
      body: this.createForm(payload),
      headers: {},
    };
    const response = await performRequest(cfrUrl.getFinsightApiUrl('/cusip-monitor/missing-deal'), option);

    return response.json();
  };
}

export default ModalFormRepository;
